var map = {
	"./arxiv_search.py": [
		77040,
		7040
	],
	"./coin_toss.py": [
		72548,
		2548
	],
	"./convert_currency.py": [
		53770,
		3770
	],
	"./documentation.py": [
		57554,
		7554
	],
	"./kitchen_sink.py": [
		37564,
		7564
	],
	"./memory.py": [
		87380,
		7380
	],
	"./python_eval.py": [
		98273,
		8273
	],
	"./random_number.py": [
		93635,
		3635
	],
	"./roll_dice.py": [
		42095,
		2095
	],
	"./weather.py": [
		42282,
		2282
	],
	"./youtube.py": [
		31053,
		1053
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 96201;
module.exports = webpackAsyncContext;